import {Box, Link, Typography} from "@mui/material";

function Copyright(props: any) {
    return (
        <Box
            style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%"
            }}
            >
            <Typography
                variant="body2"
                color="text.secondary"
                {...props}
            >
                <Link href="https://www.abk.at/impressum/" target="_blank" rel="noopener">Impressum</Link>
            </Typography>
            <Typography
                variant="body2"
                color="text.secondary"
            >
                <Link href="https://www.abk.at/datenschutz/" target="_blank" rel="noopener">Datenschutz</Link>
            </Typography>
        </Box>
    );
}

export default Copyright;
